import {
  Box,
  Button,
  Group,
  LoadingOverlay,
  Select,
  TextInput,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import { IconCheck, IconX } from "@tabler/icons-react";
import { useEffect } from "react";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { isNullOrUndefined } from "../../../_base/extension/StringExtension";
import {
  getDetailWarranteeSamsung,
  modifyWarranteeSamsung,
} from "../../../api/ApiWarranteeSamsung";
import { WarranteeSamsung } from "../../../model/TblWarranteeSamsung";
import { DatePickerInput } from "@mantine/dates";
import moment from "moment";

const EditView = ({ id, onSearch }: EditViewProps) => {
  const entity = {
    id: 0,
    indexNo: null,
    maKhachHang: null,
    tenKhachHang: null,
    sdtKhachHang: null,
    tenVatTu: null,
    maVatTu: null,
    maVach: null,
    donViTinh: null,
    maChungTu: null,
    soChungTu: null,
    maKho: null,
    maNhaCungCap: null,
    ngayChungTu: null,
    sendStatus: null,
    status: null,
    activationDate: null,
  };
  const statusOption = [
    {
      value: "N",
      label: "New",
    },
    {
      value: "S",
      label: "Success",
    },
    {
      value: "E",
      label: "Error",
    },
  ];

  const handleEditWarranteeSamsung = async (dataSubmit: WarranteeSamsung) => {
    open();
    await modifyWarranteeSamsung(dataSubmit);
    onSearch();
    close();
    modals.closeAll();
  };

  const [visible, { toggle, close, open }] = useDisclosure(false);

  const form = useForm<WarranteeSamsung>({
    initialValues: {
      ...entity,
    },
    validate: {},
  });

  const callApiGetData = async () => {
    open();
    let callapi = await getDetailWarranteeSamsung(`?id=${id}`);
    if (!isNullOrUndefined(callapi) && !isNullOrUndefined(callapi?.data)) {
      const dataApi = callapi?.data;
      if (dataApi != null && !isNullOrUndefined(dataApi)) {
        form.setValues(dataApi);
      }

      close();
    } else {
      NotificationExtension.Fails("Dữ liệu không tồn tại");
      modals.closeAll();
    }
  };

  useEffect(() => {
    callApiGetData();
  }, [id]);

  return (
    <>
      <Box
        className="flex-none"
        component="form"
        miw={950}
        maw={950}
        mx="auto"
        onSubmit={form.onSubmit((e: WarranteeSamsung) => {
          handleEditWarranteeSamsung(e);
        })}
      >
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 2 }}
        />

        <Group grow wrap="nowrap" mt="lg" gap={"lg"}>
          <TextInput
            label={"Tên khách hàng"}
            placeholder={"Nhập tên"}
            mt="md"
            type="text"
            {...form.getInputProps("tenKhachHang")}
          />
          <TextInput
            label={"Mã khách hàng"}
            placeholder={"Nhập mã"}
            mt="md"
            type="text"
            {...form.getInputProps("maKhachHang")}
          />
        </Group>

        <Group grow wrap="nowrap" mt="lg" gap={"lg"}>
          <TextInput
            label={"Số điện thoại khách hàng"}
            placeholder={"Nhập số điện thoại"}
            mt="md"
            type="text"
            {...form.getInputProps("sdtKhachHang")}
          />
          <TextInput
            label={"Mã vật tư"}
            placeholder={"Nhập mã"}
            mt="md"
            type="text"
            {...form.getInputProps("maVach")}
          />
        </Group>

        <Group grow wrap="nowrap" mt="lg" gap={"lg"}>
          <TextInput
            label={"Tên vật tư"}
            placeholder={"Nhập tên"}
            mt="md"
            type="text"
            {...form.getInputProps("tenVatTu")}
          />
        </Group>

        <Group grow wrap="nowrap" mt="lg" gap={"lg"}>
          <TextInput
            label={"Đơn vị tính"}
            placeholder={"Nhập đơn vị"}
            mt="md"
            type="text"
            {...form.getInputProps("donViTinh")}
          />
          <TextInput
            label={"Mã chứng từ"}
            placeholder={"Nhập mã"}
            mt="md"
            type="text"
            {...form.getInputProps("maChungTu")}
          />
        </Group>

        <Group grow wrap="nowrap" mt="lg" gap={"lg"}>
          <TextInput
            label={"Số chứng từ"}
            placeholder={"Nhập số"}
            mt="md"
            type="number"
            {...form.getInputProps("soChungTu")}
          />
          <TextInput
            label={"Mã kho"}
            placeholder={"Nhập mã"}
            mt="md"
            type="text"
            {...form.getInputProps("maKho")}
          />
        </Group>

        <Group grow wrap="nowrap" mt="lg" gap={"lg"}>
          <TextInput
            label={"Mã nhà cung cấp"}
            placeholder={"Nhập mã"}
            mt="md"
            type="text"
            {...form.getInputProps("maNhaCungCap")}
          />
          <DatePickerInput
            label="Ngày chứng từ"
            placeholder="Chọn ngày"
            {...form.getInputProps("ngayChungTu")}
            mt="md"
            value={
              form.getInputProps("ngayChungTu").value
                ? new Date(form.getInputProps("ngayChungTu").value)
                : null
            }
            onChange={(value) =>
              form
                .getInputProps("ngayChungTu")
                .onChange(moment(value).format("YYYY-MM-DD"))
            }
          />
        </Group>

        <Select
          label={"Trạng thái"}
          disabled
          data={statusOption}
          mt="md"
          {...form.getInputProps("sendStatus")}
        />

        <Group justify="flex-end" mt="lg">
          <Button
            type="submit"
            color="#3598dc"
            loading={visible}
            leftSection={<IconCheck size={18} />}
          >
            Lưu
          </Button>
          <Button
            variant="outline"
            color="black"
            type="button"
            loading={visible}
            onClick={() => modals.closeAll()}
            leftSection={<IconX size={18} />}
          >
            Đóng
          </Button>
        </Group>
      </Box>
    </>
  );
};

export default EditView;

type EditViewProps = {
  id: number;
  onSearch: Function;
};
